export default __webpack_public_path__ + "static/media/toggle_bg.86bbbe17.svg";